import { gql } from "@apollo/client";

// Queries

export const GET_STATUS_SINIESTRO = gql`
  query getStatusSiniestro {
    getStatusSiniestro {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_SINEISTROS = gql`
  query getSiniestroById($idSiniestro: Int!) {
    getSiniestroById(idSiniestro: $idSiniestro) {
      statusCode
      message
      response
    }
  }
`;

export const GET_SINISTER_BY_CONTRACT = gql`
  query getAllSinisterByContract($idContract: Int!) {
    getAllSinisterByContract(idContract: $idContract) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_SINISTER_BY_ID = gql`
  query getAllSinisterById($idSinester: Int!) {
    getAllSinisterById(idSinester: $idSinester) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_DOCUMENTARIES_SINESTER = gql`
  query getDocumentariesByIdSinester($idSinester: Int!) {
    getDocumentariesByIdSinester(idSinester: $idSinester) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_REMIDER_SINESTER = gql`
  query getAllRemiderByIdSinester($idSinester: Int!) {
    getAllRemiderByIdSinester(idSinester: $idSinester) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_REMIDER_DOCUMENTS = gql`
  query getDocRemiderByIdRemider($idRemider: String!) {
    getDocRemiderByIdRemider(idRemider: $idRemider) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_REMIDER_BY_SINISTER = gql`
  query getRemindersBySinister($idSinister: Int!) {
    getRemindersBySinister(idSinister: $idSinister) {
      message
      statusCode
      error
      response
    }
  }
`;
export const GET_WORD_CREATE = gql`
query wordDocumentCreate($input: inputWord) {
  wordDocumentCreate(input: $input) {
    response
    statusCode
  }
  }`;
export const GET_DATES_VALIDATION = gql`
  query getDatesValidation(
    $emiDateContract: String
    $dateReport: String
    $dateEmi: String
    $dateFollow: String
    $startDateContract: String
    $endDateContract: String
    $status: status
  ) {
    getDatesValidation(
      emiDateContract: $emiDateContract
      dateFollow: $dateFollow
      dateReport: $dateReport
      dateEmi: $dateEmi
      startDateContract: $startDateContract
      endDateContract: $endDateContract
      status: $status
    ) {
      statusCode
      message
      error
      response
    }
  }
`;

// Mutations

export const CREATE_SINIESTRO = gql`
  mutation createSiniestro($input: siniestroInput) {
    createSiniestro(input: $input) {
      statusCode
      message
      error
      response
    }
  }
`;
export const UPDATE_MOVEMENTS = gql`
  mutation updateMovements($siniestro_id: Int, $movimientos: String) {
    updateMovements(siniestro_id: $siniestro_id, movimientos: $movimientos) {
      statusCode
      message
      error
      response
    }
  }
`;
export const CREATE_SEGUIMIENTO = gql`
  mutation createSeguimiento($input: seguimientoInput) {
    createSeguimiento(input: $input) {
      statusCode
      message
      error
      response
    }
  }
`;

export const CREATE_DOC_SINIESTRO = gql`
  mutation createDocumentalSiniestro($input: documentalSinInput) {
    createDocumentalSiniestro(input: $input) {
      statusCode
      message
      error
      response
    }
  }
`;

export const CREATE_DOC_REMIDER = gql`
  mutation createDocRemider($input: docRemiderInput) {
    createDocRemider(input: $input) {
      statusCode
      message
      error
      response
    }
  }
`;

export const UPLOAD_FILE_DOCUMENT = gql`
  mutation uploadDocuments(
    $fileDocument: Upload
    $keyword: String
    $fileSize: Int
  ) {
    uploadDocuments(
      fileDocument: $fileDocument
      keyword: $keyword
      fileSize: $fileSize
    ) {
      statusCode
      message
      error
      response
    }
  }
`;

export const UPDATE_REMINDER = gql`
  mutation updateReminder($recordatorio_id: Int) {
    updateReminder(recordatorio_id: $recordatorio_id) {
      statusCode
      message
      error
      response
    }
  }
`;
